/**
 * Case-insensitiver String-Vergleich für `Array.prototype.sort`.
 *
 * Bewusst kein `localeCompare(…, 'de')`: dessen Ergebnis hängt vom ICU der jeweiligen
 * Laufzeit ab. Server (Node/SSR) und Browser können unterschiedliche ICU-Daten mitbringen
 * und damit unterschiedlich sortieren — bei einer `@for`-Liste, die im SSR-HTML steht und
 * danach hydriert wird, führt das zu einem Node-Mismatch bei der Hydration. Der einfache
 * Vergleich über `toLowerCase()` liefert auf jeder Laufzeit dieselbe Reihenfolge.
 */
export function compareAlphabetically(a: string, b: string): number {
    const keyA = a.toLowerCase();
    const keyB = b.toLowerCase();
    return keyA < keyB ? -1 : keyA > keyB ? 1 : 0;
}
